import { render, staticRenderFns } from "./store-item-box.vue?vue&type=template&id=1c90a910&scoped=true"
import script from "./store-item-box.vue?vue&type=script&lang=js"
export * from "./store-item-box.vue?vue&type=script&lang=js"
import style0 from "./store-item-box.vue?vue&type=style&index=0&id=1c90a910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c90a910",
  null
  
)

export default component.exports